<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">General Settings - Contact Us</h5>
      <br />
    </div>
    <b-row>
      <b-col md="4">
        <b-card class="text-left">
          <b>Edit Contact Us</b>
          <b-row class="mt-4">
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="Phone Number"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required|numeric'"
                  v-model="items.phone"
                  name="phone_number"
                  data-vv-as="Phone Number"
                  id="input-1"
                  class="form-control"
                  placeholder="Phone Number"
                />
                <b-form-invalid-feedback
                  id="input-phone_number-feedback"
                >{{ veeErrors.first('phone_number') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="Email Address"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="'required|email'"
                  v-model="items.email"
                  name="email_address"
                  data-vv-as="Email Address"
                  class="form-control"
                  placeholder="Email Address"
                />
                <b-form-invalid-feedback
                  id="input-email_address-feedback"
                >{{ veeErrors.first('email_address') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col md="4" class="text-left">
              <label class="text-danger">
                *
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col>
              <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">
                Save
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
              <router-link :to="{name: 'GeneralContactUs'}">
                <b-button variant="outline-secondary" size="lg">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      items: [],
      phone_number: null,
      email_address: null,
    };
  },
  beforeCreate() {
    this.$store
      .dispatch('GeneralSettingsModule/getContactUsId', this.$route.params.id)
      .then((response) => {
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: 'error',
          title: 'Oops...',
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
  },
  created() {
    this.$store.watch(
      state => state.GeneralSettingsModule.contact_us_id,
      (newValue, oldValue) => {
        this.items = newValue;
      },
    );
  },
  methods: {
    put() {
      this.$swal({
        title: 'Are you sure?',
        text: 'You will update this Contact Us!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, update it!',
      }).then((result) => {
        if (result.value) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append('phone', this.items.phone);
              formData.append('email', this.items.email);
              this.$store
                .dispatch('GeneralSettingsModule/putContactUs', {
                  id: this.$route.params.id,
                  formData,
                })
                .then((response) => {
                  this.loading = false;
                  this.$router.push({ name: 'GeneralContactUs' });
                  this.$swal({
                    type: 'success',
                    title: 'Your work has been saved',
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(response);
                })
                .catch((error) => {
                  this.loading = false;
                  this.$swal({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.serverError = error.response.data;
                  console.log(error);
                });
            } else {
              this.$swal('ERROR!', 'Your file cant be submit.', 'warning');
            }
          });
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit('input', files[0]);
      }
    },
  },
};
</script>

<style>
</style>
